import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import validate from './validate';
import { Divider, Form, Row, Icon } from "antd";
import { RTLButton, RTLCol } from "../RTLKit";
import SelectField from "../formFields/SelectField";
import moment from "jalali-moment";

class WizardFormForthPage extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getDate() {
        const date = new Date();
        const formatter = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
        });
        const parts = formatter.formatToParts(date);
        function persianNumberToEnglish(str) {
            return str.replace(/[\u06F0-\u06F9]/g, (d) => d.charCodeAt(0) - 0x06F0);
        }
        const year = persianNumberToEnglish(parts.find(p => p.type === 'year')?.value || '');
        const month = persianNumberToEnglish(parts.find(p => p.type === 'month')?.value || '');
        const day = persianNumberToEnglish(parts.find(p => p.type === 'day')?.value || '');

        return {
            year: year,
            month: month,
            day: day
        }
    }

    // __showDay(){
    //     let day = [{label: 'روز', value: 0, key: 0}];
    //     for (let i = parseInt(this.getDate().day); i < 32; i++) {

    //         day.push(
    //             {label: i, value: i, key: i}
    //         );

    //     }
    //     return day;
    // }

    // __showMonth(){
    //     let month = [];

    //     month.push(
    //         {label: 'فروردین', value: 1, key: 1},
    //         {label: 'اردیبهشت', value: 2, key: 2},
    //         {label: 'خرداد', value: 3, key: 3},
    //         {label: 'تیر', value: 4, key: 4},
    //         {label: 'مرداد', value: 5, key: 5},
    //         {label: 'شهریور', value: 6, key: 6},
    //         {label: 'مهر', value: 7, key: 7},
    //         {label: 'آبان', value: 8, key: 8},
    //         {label: 'آذر', value: 9, key: 9},
    //         {label: 'دی', value: 10, key: 10},
    //         {label: 'بهمن', value: 11, key: 11},
    //         {label: 'اسفند', value: 12, key: 12},
    //     );

    //     const filtered = month.filter(m => m.value >= parseInt(this.getDate().month));
    //     return [{ label: 'ماه', value: 0, key: 0 }, ...filtered];
    // }

    __showDay() {
        let day = [{ label: 'روز', value: 0, key: 0 }];
        for (let i = 1; i < 32; i++) {

            day.push(
                { label: i, value: i, key: i }
            );

        }
        return day;
    }

    __showMonth() {
        let month = [];

        month.push(
            { label: 'ماه', value: 0, key: 0 },
            { label: 'فروردین', value: 1, key: 1 },
            { label: 'اردیبهشت', value: 2, key: 2 },
            { label: 'خرداد', value: 3, key: 3 },
            { label: 'تیر', value: 4, key: 4 },
            { label: 'مرداد', value: 5, key: 5 },
            { label: 'شهریور', value: 6, key: 6 },
            { label: 'مهر', value: 7, key: 7 },
            { label: 'آبان', value: 8, key: 8 },
            { label: 'آذر', value: 9, key: 9 },
            { label: 'دی', value: 10, key: 10 },
            { label: 'بهمن', value: 11, key: 11 },
            { label: 'اسفند', value: 12, key: 12 },
        );

        return month;
    }

    __showYear() {
        let year = [{ label: 'سال', value: 0, key: 0 }];
        for (let i = parseInt(this.getDate().year); i < parseInt(this.getDate().year) + 10; i++) {

            year.push(
                { label: i, value: i, key: i }
            );

        }
        return year;
    }

    __showHour() {
        let hour = [];
        for (let i = 1; i < 25; i++) {

            hour.push(
                { label: i, value: i, key: i }
            );

        }
        return hour;
    }

    __showMinute() {
        let minute = [];

        minute.push(
            { label: '00', value: '00', key: 1 },
            { label: '15', value: '15', key: 2 },
            { label: '30', value: '30', key: 3 },
            { label: '45', value: '45', key: 4 }
        );

        return minute;
    }

    render() {
        var _self = this;
        const { formLayout } = this.state;

        const { handleSubmit, pristine, previousPage, submitting, submitSucceeded } = this.props;
        return (
            submitSucceeded && submitSucceeded === true ?
                <form onSubmit={handleSubmit}>
                    <Row>
                        <Divider orientation="left">زمان خدمت / تماس مجدد</Divider>
                    </Row>
                    <Row type="flex" justify="start" align="middle">
                        <RTLCol md={18} sm={24} type="flex" justify="start" align="middle" >
                            <Row gutter={16}>

                                <div>
                                    <RTLCol md={24}>
                                        <RTLCol md={5} sm={24} type="flex" justify="start" align="middle" >
                                            <label>انتخاب تاریخ :</label>
                                        </RTLCol>
                                        <RTLCol md={4} sm={5} type="flex" justify="start" align="middle" >
                                            <Field
                                                name="day"
                                                component={SelectField}
                                                list={this.__showDay()}
                                                defaultValue={0}
                                            />
                                        </RTLCol>
                                        <RTLCol md={4} sm={5} type="flex" justify="start" align="middle" >
                                            <Field
                                                name="month"
                                                component={SelectField}
                                                list={this.__showMonth()}
                                                defaultValue={0}
                                            />
                                        </RTLCol>
                                        <RTLCol md={4} sm={5} type="flex" justify="start" align="middle" >
                                            <Field
                                                name="year"
                                                component={SelectField}
                                                list={this.__showYear()}
                                                defaultValue={0}
                                            />
                                        </RTLCol>
                                    </RTLCol>
                                </div>

                            </Row>
                        </RTLCol>
                    </Row>
                    <Row>
                        <RTLButton type="primary" shape="round" htmlType="submit" className="login-form-button" disabled={pristine || submitting}>
                            ثبت
                        </RTLButton>
                        <RTLButton className="backBtn" type="default" shape="round" onClick={previousPage}>
                            مرحله قبل
                        </RTLButton>
                    </Row>
                </form>
                :
                <Row>
                    <RTLCol style={{ textAlign: 'center' }}>درخواست شما با موفقیت ثبت شد</RTLCol>
                    <RTLCol style={{ textAlign: 'center', fontSize: 30 }}>
                        <Icon type="check-circle" />
                    </RTLCol>
                </Row>
        );
    }
};

export default reduxForm({
    form: 'wizard', //                 <------ same form name
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate,
})(WizardFormForthPage);
